import { render, staticRenderFns } from "./inform.vue?vue&type=template&id=22fa132e&scoped=true&"
import script from "./inform.vue?vue&type=script&lang=js&"
export * from "./inform.vue?vue&type=script&lang=js&"
import style0 from "./inform.vue?vue&type=style&index=0&id=22fa132e&prod&lang=css&"
import style1 from "./inform.vue?vue&type=style&index=1&id=22fa132e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fa132e",
  null
  
)

export default component.exports